import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pinned-messages"
export default class extends Controller {
  static targets = [
    "pinnedMessage",
    "text",
    "number",
    "prevButton",
    "nextButton"
  ]
  static values = {
    messagesList: {
      type: Array,
      default: []
    }
  }

  connect() {
    if (this.messagesListValue.length > 0) {
      this.updateButtonState(0)
    }
  }

  prev() {
    this.navigate(-1)
  }

  next() {
    this.navigate(1)
  }

  navigate(direction) {
    const currentId = +this.pinnedMessageTarget.dataset.pinnedMessageId
    const currentIndex = this.messagesListValue.findIndex(m => m.id === currentId)
    const newIndex = currentIndex + direction
    const newMessage = this.messagesListValue[newIndex]

    if (!newMessage) return

    this.pinnedMessageTarget.dataset.pinnedMessageId = newMessage.id
    this.pinnedMessageTarget.dataset.targetMessageId = newMessage.id
    this.textTarget.innerHTML = this.formatBadwordText(newMessage.text)
    this.numberTarget.innerText = `#${newIndex + 1}`

    this.updateButtonState(newIndex)
  }

  updateButtonState(index) {
    if (!this.hasPrevButtonTarget || !this.hasNextButtonTarget) return

    const lastIndex = this.messagesListValue.length - 1

    this.prevButtonTarget.classList.toggle("disabled", index === 0)
    this.nextButtonTarget.classList.toggle("disabled", index === lastIndex)
  }

  formatBadwordText(text) {
    if (!text) return ''

    const div = document.createElement('div')
    div.textContent = text
    const escapedText = div.innerHTML

    return escapedText.replace(/\[badword\](.*?)\[\/badword\]/g, "<span class='bad-word'>$1</span>")
  }
}
